import { config } from "../config";
import { authHeader } from "../helpers";
import axios from "axios";

export const userFunctionService = {
  getAll,
  getById,
  create,
  update,
  remove,
};

function getAll() {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };

  return axios
    .get(`${config.userFunction_server}/`, requestOptions)
    .then((responce) => {
      return responce.data;
    });
}

function getById(id) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };

  return axios
    .get(`${config.userFunction_server}/${id}`, requestOptions)
    .then((responce) => {
      return responce.data;
    });
}

function create(data) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };

  return axios
    .post(`${config.userFunction_server}/`, data, requestOptions)
    .then((responce) => {
      return responce.data;
    });
}

function update(id, data) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };

  return axios
    .put(`${config.userFunction_server}/${id}`, data, requestOptions)
    .then((responce) => {
      return responce.data;
    });
}

function remove(id) {
  const requestOptions = {
    method: "DELETE",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };

  return axios
    .delete(`${config.userFunction_server}/${id}`, requestOptions)
    .then((responce) => {
      return responce.data;
    });
}
